// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_scribe_catalog.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * CatalogStatus is the lifecycle state of a scribe catalog entity: encounter
 * schema, document template or analytics model.
 *
 * @generated from enum com.diagnocat.model.CatalogStatus
 */
export const CatalogStatus = proto3.makeEnum(
  "com.diagnocat.model.CatalogStatus",
  [
    {no: 0, name: "CatalogStatusInvalidValue"},
    {no: 1, name: "CatalogStatusActive"},
    {no: 2, name: "CatalogStatusDraft"},
    {no: 3, name: "CatalogStatusDeleted"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.ChecklistGenerationStatus
 */
export const ChecklistGenerationStatus = proto3.makeEnum(
  "com.diagnocat.model.ChecklistGenerationStatus",
  [
    {no: 0, name: "ChecklistGenerationStatusInvalidValue"},
    {no: 1, name: "ChecklistGenerationStatusPending"},
    {no: 2, name: "ChecklistGenerationStatusProcessing"},
    {no: 3, name: "ChecklistGenerationStatusCompleted"},
    {no: 4, name: "ChecklistGenerationStatusFailed"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.RegistryAssetFamily
 */
export const RegistryAssetFamily = proto3.makeEnum(
  "com.diagnocat.model.RegistryAssetFamily",
  [
    {no: 0, name: "RegistryAssetFamilyInvalidValue"},
    {no: 1, name: "RegistryAssetFamilyDocumentTemplate"},
    {no: 2, name: "RegistryAssetFamilyEncounterSchema"},
    {no: 3, name: "RegistryAssetFamilyAnalyticsModel"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.RegistrySourceKind
 */
export const RegistrySourceKind = proto3.makeEnum(
  "com.diagnocat.model.RegistrySourceKind",
  [
    {no: 0, name: "RegistrySourceKindInvalidValue"},
    {no: 1, name: "RegistrySourceKindSystem"},
    {no: 2, name: "RegistrySourceKindCommunity"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.RegistryOriginKind
 */
export const RegistryOriginKind = proto3.makeEnum(
  "com.diagnocat.model.RegistryOriginKind",
  [
    {no: 0, name: "RegistryOriginKindInvalidValue"},
    {no: 1, name: "RegistryOriginKindOfficial"},
    {no: 2, name: "RegistryOriginKindCommunity"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.SchemaDocumentInclusion
 */
export const SchemaDocumentInclusion = proto3.makeEnum(
  "com.diagnocat.model.SchemaDocumentInclusion",
  [
    {no: 0, name: "SchemaDocumentInclusionInvalidValue"},
    {no: 1, name: "SchemaDocumentInclusionAlways"},
    {no: 2, name: "SchemaDocumentInclusionOnDemand"},
  ],
);

/**
 * RegistryAsset is one row of the cross-family catalog browser: encounter
 * schemas, document templates and analytics models an organization can adopt,
 * in one listing. The per-family count fields are set only for the family the
 * row belongs to.
 *
 * @generated from message com.diagnocat.model.RegistryAsset
 */
export const RegistryAsset = proto3.makeMessageType(
  "com.diagnocat.model.RegistryAsset",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Family", kind: "enum", T: proto3.getEnumType(RegistryAssetFamily) },
    { no: 3, name: "SourceKind", kind: "enum", T: proto3.getEnumType(RegistrySourceKind) },
    { no: 4, name: "OriginKind", kind: "enum", T: proto3.getEnumType(RegistryOriginKind) },
    { no: 5, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "TemplateType", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "SectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "DocumentCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "AnalyticsGroupsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 12, name: "AnalyticsSectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "AuthorDisplayName", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "AuthorSpecialty", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "Specialty", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 17, name: "ImportCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 18, name: "HasLocalClone", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "LocalCloneID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.EncounterSchema
 */
export const EncounterSchema = proto3.makeMessageType(
  "com.diagnocat.model.EncounterSchema",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 5, name: "IsSystem", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "AnalyticsModelSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "Documents", kind: "message", T: SchemaDocumentRef, repeated: true },
    { no: 15, name: "AlwaysDocumentCodes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "OnDemandDocumentCodes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "AlwaysDocumentSeriesIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 18, name: "OnDemandDocumentSeriesIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "DocumentCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 21, name: "CreatedBy", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * EncounterSchemaSummary is the list projection of EncounterSchema: it keeps
 * the document refs but drops the derived code and series-id lists.
 *
 * @generated from message com.diagnocat.model.EncounterSchemaSummary
 */
export const EncounterSchemaSummary = proto3.makeMessageType(
  "com.diagnocat.model.EncounterSchemaSummary",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 5, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "AnalyticsModelSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "Documents", kind: "message", T: SchemaDocumentRef, repeated: true },
    { no: 14, name: "DocumentCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "CreatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * SchemaDocumentRefList carries a document list where an unset list has to
 * mean something different from an empty one: proto3 gives a bare repeated
 * field no presence, so an update could never clear the last document.
 *
 * @generated from message com.diagnocat.model.SchemaDocumentRefList
 */
export const SchemaDocumentRefList = proto3.makeMessageType(
  "com.diagnocat.model.SchemaDocumentRefList",
  () => [
    { no: 1, name: "Documents", kind: "message", T: SchemaDocumentRef, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.SchemaDocumentRef
 */
export const SchemaDocumentRef = proto3.makeMessageType(
  "com.diagnocat.model.SchemaDocumentRef",
  () => [
    { no: 1, name: "TemplateSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Inclusion", kind: "enum", T: proto3.getEnumType(SchemaDocumentInclusion) },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * SchemaUsageSummary counts the encounters actually captured under a schema
 * code, which can differ from the catalog in both directions: a seeded schema
 * nobody used yet is absent, a custom schema captured on encounters but never
 * added to the catalog is present.
 *
 * @generated from message com.diagnocat.model.SchemaUsageSummary
 */
export const SchemaUsageSummary = proto3.makeMessageType(
  "com.diagnocat.model.SchemaUsageSummary",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.DocumentTemplate
 */
export const DocumentTemplate = proto3.makeMessageType(
  "com.diagnocat.model.DocumentTemplate",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 7, name: "IsSystem", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "Sections", kind: "message", T: DocumentSectionSpec, repeated: true },
    { no: 17, name: "CatalogListing", kind: "message", T: CatalogListing, opt: true },
    { no: 18, name: "CatalogPublished", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "Checklist", kind: "message", T: TemplateChecklist, opt: true },
    { no: 22, name: "SourceDocument", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 21, name: "UpdatedAt", kind: "message", T: Timestamp, opt: true },
  ],
);

/**
 * DocumentTemplateSummary is the list projection of DocumentTemplate: every
 * field except Sections, CatalogListing and Checklist.
 *
 * @generated from message com.diagnocat.model.DocumentTemplateSummary
 */
export const DocumentTemplateSummary = proto3.makeMessageType(
  "com.diagnocat.model.DocumentTemplateSummary",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 7, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "SectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "CatalogPublished", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 18, name: "UpdatedAt", kind: "message", T: Timestamp, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.DocumentSectionSpec
 */
export const DocumentSectionSpec = proto3.makeMessageType(
  "com.diagnocat.model.DocumentSectionSpec",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "EditorType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "ProcessingType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "Options", kind: "message", T: SectionOption, repeated: true },
    { no: 10, name: "TemplateType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.SectionOption
 */
export const SectionOption = proto3.makeMessageType(
  "com.diagnocat.model.SectionOption",
  () => [
    { no: 1, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Slots", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SlotValues} },
    { no: 3, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "SlotInstructions", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message com.diagnocat.model.SlotValues
 */
export const SlotValues = proto3.makeMessageType(
  "com.diagnocat.model.SlotValues",
  () => [
    { no: 1, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.TemplateChecklist
 */
export const TemplateChecklist = proto3.makeMessageType(
  "com.diagnocat.model.TemplateChecklist",
  () => [
    { no: 1, name: "Status", kind: "enum", T: proto3.getEnumType(ChecklistGenerationStatus) },
    { no: 2, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Content", kind: "message", T: ChecklistContent, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.ChecklistContent
 */
export const ChecklistContent = proto3.makeMessageType(
  "com.diagnocat.model.ChecklistContent",
  () => [
    { no: 1, name: "Items", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "GeneratedAt", kind: "message", T: Timestamp },
    { no: 3, name: "Model", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * CatalogListing is what an organization wrote about its own template when it
 * published it. Specialty and Category fall back to catalog defaults when the
 * publisher left them empty.
 *
 * @generated from message com.diagnocat.model.CatalogListing
 */
export const CatalogListing = proto3.makeMessageType(
  "com.diagnocat.model.CatalogListing",
  () => [
    { no: 1, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "Specialty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Location", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "ImportCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "PublishedAt", kind: "message", T: Timestamp, opt: true },
  ],
);

/**
 * CommunityDocumentTemplate is a published template as the community catalog
 * presents it, with its publisher attribution resolved.
 *
 * @generated from message com.diagnocat.model.CommunityDocumentTemplate
 */
export const CommunityDocumentTemplate = proto3.makeMessageType(
  "com.diagnocat.model.CommunityDocumentTemplate",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Specialty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "Location", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "Tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "AuthorDisplayName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "AuthorSpecialty", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "SourceTemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "SourceSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "SourceOrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 17, name: "Sections", kind: "message", T: DocumentSectionSpec, repeated: true },
    { no: 18, name: "ImportCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "SectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "PublishedAt", kind: "message", T: Timestamp, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsModel
 */
export const AnalyticsModel = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsModel",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 7, name: "IsSystem", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "Tags", kind: "message", T: AnalyticsTagsConfig },
    { no: 14, name: "Sections", kind: "message", T: AnalyticsSectionSpec, repeated: true },
    { no: 15, name: "AnalyticsGroupsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "AnalyticsSectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "CreatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * AnalyticsModelSummary is the list projection of AnalyticsModel: every field
 * except Tags and Sections.
 *
 * @generated from message com.diagnocat.model.AnalyticsModelSummary
 */
export const AnalyticsModelSummary = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsModelSummary",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 7, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "AnalyticsGroupsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "AnalyticsSectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "CreatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsTagsConfig
 */
export const AnalyticsTagsConfig = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsTagsConfig",
  () => [
    { no: 1, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "Groups", kind: "message", T: AnalyticsTagGroup, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsTagGroup
 */
export const AnalyticsTagGroup = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsTagGroup",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "SelectionMode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "Tags", kind: "message", T: AnalyticsTagSpec, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsTagSpec
 */
export const AnalyticsTagSpec = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsTagSpec",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Explain", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * AnalyticsSectionSpecList carries a section list with presence, for the same
 * reason as SchemaDocumentRefList.
 *
 * @generated from message com.diagnocat.model.AnalyticsSectionSpecList
 */
export const AnalyticsSectionSpecList = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsSectionSpecList",
  () => [
    { no: 1, name: "Sections", kind: "message", T: AnalyticsSectionSpec, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsSectionSpec
 */
export const AnalyticsSectionSpec = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsSectionSpec",
  () => [
    { no: 1, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * CatalogCloneOverride names one source asset to clone into the target
 * organization, optionally renaming it. Shared by the clone RPCs of all three
 * catalog services.
 *
 * @generated from message com.diagnocat.model.CatalogCloneOverride
 */
export const CatalogCloneOverride = proto3.makeMessageType(
  "com.diagnocat.model.CatalogCloneOverride",
  () => [
    { no: 1, name: "Family", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "SourceAssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.CatalogCloneResult
 */
export const CatalogCloneResult = proto3.makeMessageType(
  "com.diagnocat.model.CatalogCloneResult",
  () => [
    { no: 1, name: "LocalAssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LocalSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "ReusedExisting", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

